import React, { useState, useEffect } from 'react';
import { Users, Gift, Zap } from 'lucide-react';

const UrgencyBanner = () => {
  const [slotsRemaining, setSlotsRemaining] = useState(47);
  const [timeLeft, setTimeLeft] = useState({
    hours: 4,
    minutes: 23,
    seconds: 15
  });

  // Countdown timer effect
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let { hours, minutes, seconds } = prev;
        
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) {
          hours = 4;
          minutes = 23;
          seconds = 15;
        }
        
        return { hours, minutes, seconds };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Simulate slots decreasing
  useEffect(() => {
    const slotsTimer = setInterval(() => {
      setSlotsRemaining(prev => {
        const newValue = prev - 1;
        return newValue < 30 ? 47 : newValue;
      });
    }, 45000);

    return () => clearInterval(slotsTimer);
  }, []);

  return (
    <div style={{
      background: 'linear-gradient(135deg, rgba(255, 68, 68, 0.1) 0%, rgba(255, 165, 0, 0.08) 50%, rgba(201, 160, 75, 0.1) 100%)',
      borderTop: '2px solid rgba(255, 165, 0, 0.3)',
      borderBottom: '2px solid rgba(255, 165, 0, 0.3)',
      padding: '24px 0'
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '0 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        gap: '40px',
        flexWrap: 'wrap'
      }}>
        {/* Limited Slots */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', minWidth: '280px' }}>
          <div style={{
            width: '56px',
            height: '56px',
            borderRadius: '14px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, rgba(255, 68, 68, 0.2), rgba(255, 68, 68, 0.1))',
            boxShadow: '0 0 20px rgba(255, 68, 68, 0.3)'
          }}>
            <Users style={{ width: '28px', height: '28px', color: '#FF4444' }} />
          </div>
          <div>
            <div style={{ fontSize: '0.8125rem', color: 'rgba(245, 241, 229, 0.6)', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Limited Slots
            </div>
            <div style={{ fontSize: '1rem', color: 'var(--sahara-beige)', fontWeight: 600 }}>
              <span style={{ fontSize: '1.5rem', fontWeight: 800, color: '#FF4444' }}>{slotsRemaining}</span>
              <span style={{ marginLeft: '4px' }}>/100 remaining today</span>
            </div>
          </div>
        </div>

        {/* Separator */}
        <div style={{ width: '2px', height: '50px', background: 'linear-gradient(180deg, transparent, rgba(255, 165, 0, 0.5), transparent)' }} />

        {/* Early Bird Bonus */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', minWidth: '320px' }}>
          <div style={{
            width: '56px',
            height: '56px',
            borderRadius: '14px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, rgba(201, 160, 75, 0.2), rgba(201, 160, 75, 0.1))',
            boxShadow: '0 0 20px rgba(201, 160, 75, 0.3)'
          }}>
            <Gift style={{ width: '28px', height: '28px', color: 'var(--sahara-gold)' }} />
          </div>
          <div>
            <div style={{ fontSize: '0.8125rem', color: 'rgba(245, 241, 229, 0.6)', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Early Bird Bonus
            </div>
            <div style={{ fontSize: '1rem', color: 'var(--sahara-beige)', fontWeight: 600 }}>
              First 50 users: <span style={{ color: 'var(--sahara-gold)', fontWeight: 700 }}>0% fees for 1 month</span>
            </div>
          </div>
        </div>

        {/* Separator */}
        <div style={{ width: '2px', height: '50px', background: 'linear-gradient(180deg, transparent, rgba(255, 165, 0, 0.5), transparent)' }} />

        {/* Flash Offer Timer */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', minWidth: '280px' }}>
          <div style={{
            width: '56px',
            height: '56px',
            borderRadius: '14px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, rgba(255, 165, 0, 0.2), rgba(255, 165, 0, 0.1))',
            boxShadow: '0 0 20px rgba(255, 165, 0, 0.3)'
          }}>
            <Zap style={{ width: '28px', height: '28px', color: '#FFA500' }} />
          </div>
          <div>
            <div style={{ fontSize: '0.8125rem', color: 'rgba(245, 241, 229, 0.6)', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Flash Offer Ends In
            </div>
            <div style={{ fontSize: '1rem', color: 'var(--sahara-beige)', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '4px' }}>
              <span style={{ fontSize: '1.5rem', fontWeight: 800, color: '#FFA500', fontFamily: "'Space Grotesk', monospace" }}>
                {String(timeLeft.hours).padStart(2, '0')}
              </span>
              <span style={{ fontSize: '0.75rem' }}>h</span>
              <span style={{ fontSize: '1.25rem', color: 'rgba(245, 241, 229, 0.4)' }}>:</span>
              <span style={{ fontSize: '1.5rem', fontWeight: 800, color: '#FFA500', fontFamily: "'Space Grotesk', monospace" }}>
                {String(timeLeft.minutes).padStart(2, '0')}
              </span>
              <span style={{ fontSize: '0.75rem' }}>m</span>
              <span style={{ fontSize: '1.25rem', color: 'rgba(245, 241, 229, 0.4)' }}>:</span>
              <span style={{ fontSize: '1.5rem', fontWeight: 800, color: '#FFA500', fontFamily: "'Space Grotesk', monospace" }}>
                {String(timeLeft.seconds).padStart(2, '0')}
              </span>
              <span style={{ fontSize: '0.75rem' }}>s</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UrgencyBanner;
